import { useState } from 'react';
import { useAppStore } from '@/app/store';
import { Dialog } from '@/components/ui/dialog';
import { toast } from '@/components/feedback/toast';
import { TaskForm } from './task-form';
import { createManualTask, createTaskTemplate, defaultTaskFormData } from './task-service';

export function QuickTaskDialog() {
  const open = useAppStore((state) => state.commandOpen);
  const setOpen = useAppStore((state) => state.setCommandOpen);
  const [key, setKey] = useState(0);

  return (
    <Dialog
      description="Ein klarer nächster Schritt. Details kannst du jederzeit später ergänzen."
      onOpenChange={setOpen}
      open={open}
      title="Neue Aufgabe"
    >
      <TaskForm
        defaultValues={defaultTaskFormData()}
        key={key}
        onCancel={() => setOpen(false)}
        onSubmit={async (data) => {
          if (data.recurrenceKind === 'once') {
            const task = await createManualTask(data);
            toast('Aufgabe erstellt', {
              description: `„${task.title}“ wurde lokal gespeichert.`
            });
          } else {
            const template = await createTaskTemplate(data);
            toast('Wiederkehrende Aufgabe erstellt', {
              description: `„${template.title}“ wird nach deiner Regel eingeplant.`
            });
          }
          setOpen(false);
          setKey((value) => value + 1);
        }}
      />
    </Dialog>
  );
}
